import { markRaw } from 'vue'
import PopupAbstract from './PopupAbstract'
import PopupPicker from './PopupPicker.vue'

export default class PopupPickerService extends PopupAbstract {
  public name = 'PopupPickerService'
  protected component = markRaw(PopupPicker)
}
